// extracted by mini-css-extract-plugin
export default {"active":"Header_active__5MDhj","navLink":"Header_navLink__-fS+d"};